<p-toast></p-toast>

<div class="card">
    <div class="flex align-items-center justify-content-between mb-3">
        <h2 class="text-xl font-medium m-0">Flex Field Configuration</h2>
        <div class="flex align-items-center gap-2">
            <button pButton type="button" icon="pi pi-refresh" label="Reload" class="p-button-secondary"
                (click)="reset()" [disabled]="isLoading || isSaving"></button>
            <button pButton type="button" icon="pi pi-save" label="Save Changes" (click)="save()"
                [disabled]="form.invalid || isSaving || isLoading"></button>
        </div>
    </div>

    <p-progressBar *ngIf="isLoading" mode="indeterminate" styleClass="mb-3"></p-progressBar>

    <form [formGroup]="form">
        <div formArrayName="businessObjects">
            <p-accordion [multiple]="true" [value]="['0']">
            @for (group of businessObjects.controls; track trackBusinessObject($index, group); let i = $index) {
            <div [formGroupName]="i">
                <p-accordion-panel [value]="i.toString()">
                    <p-accordion-header>
                        {{ formatBusinessObjectLabel(group.get('businessObject')?.value) }}
                    </p-accordion-header>
                    <p-accordion-content>
                        <div class="flex align-items-center justify-content-between mb-3">
                            <span class="font-semibold">
                                {{ group.get('businessObject')?.value }}
                            </span>
                            <button pButton type="button" icon="pi pi-plus" label="Add Field" (click)="addConfig(i)"
                                class=""></button>
                        </div>
                        <div formArrayName="configs" class="flex flex-column gap-3">
                            @if (getConfigArray(i).controls.length === 0) {
                            <div class="p-3 surface-border border-1 border-round surface-100 text-600">
                                No flex fields defined for this business object yet.
                            </div>
                            } @else {
                            @for (configGroup of getConfigArray(i).controls; track trackConfig($index, configGroup); let
                            j = $index) {
                            <div class="p-3 border-1 surface-border border-round surface-card" [formGroupName]="j">
                                <div class="grid formgrid p-fluid">
                                    <div class="field col-12 md:col-6 lg:col-4">
                                        <p-inputGroup>
                                            <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
                                            <p-iftaLabel>
                                                <input id="fieldName-{{i}}-{{j}}" type="text" pInputText formControlName="fieldName" />
                                                <label for="fieldName-{{i}}-{{j}}">Field Name</label>
                                            </p-iftaLabel>
                                        </p-inputGroup>
                                    </div>
                                    <div class="field col-12 md:col-6 lg:col-4">
                                        <p-inputGroup>
                                            <p-inputGroupAddon><i class="pi pi-clone"></i></p-inputGroupAddon>
                                            <p-iftaLabel>
                                                <input id="altFieldName-{{i}}-{{j}}" type="text" pInputText formControlName="alternateFieldName" />
                                                <label for="altFieldName-{{i}}-{{j}}">Alternate Name</label>
                                            </p-iftaLabel>
                                        </p-inputGroup>
                                    </div>
                                    <div class="field col-12 md:col-6 lg:col-4">
                                        <p-inputGroup>
                                            <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
                                            <p-iftaLabel>
                                                <p-select id="dataType-{{i}}-{{j}}" formControlName="dataType" [options]="dataTypeOptions" optionLabel="label" optionValue="value" styleClass="w-full"></p-select>
                                                <label for="dataType-{{i}}-{{j}}">Data Type</label>
                                            </p-iftaLabel>
                                        </p-inputGroup>
                                    </div>
                                    <div class="field col-12 md:col-6 lg:col-4">
                                        <p-inputGroup>
                                            <p-inputGroupAddon><i class="pi pi-arrows-h"></i></p-inputGroupAddon>
                                            <p-iftaLabel>
                                                <input id="fieldLength-{{i}}-{{j}}" type="number" pInputText formControlName="fieldLength" />
                                                <label for="fieldLength-{{i}}-{{j}}">Field Length</label>
                                            </p-iftaLabel>
                                        </p-inputGroup>
                                    </div>
                                    <div class="field col-6 md:col-3 lg:col-2 flex align-items-center gap-2 pt-3">
                                        <label class="font-medium m-0">Required</label>
                                        <p-toggleswitch formControlName="required"></p-toggleswitch>
                                    </div>
                                    <div class="field col-6 md:col-3 lg:col-2 flex align-items-center gap-2 pt-3">
                                        <label class="font-medium m-0">Active</label>
                                        <p-toggleswitch formControlName="active"></p-toggleswitch>
                                    </div>
                                </div>
                                <div class="flex justify-content-end">
                                    <button pButton type="button" icon="pi pi-trash"
                                        class="p-button-text p-button-danger" (click)="removeConfig(i, j)"></button>
                                </div>
                            </div>
                            }
                            }
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            </div>
            }
            </p-accordion>
        </div>
    </form>
</div>
